/**
 * Feature flag constants for use with Statsig.
 */
import {AEO_FLAG_NAMES} from './constants/aeo';
import {AETHER_FLAG_NAMES} from './constants/aether';
import {AGENT_ACCESS_FLAG_NAMES} from './constants/agent-access';
import {AI_DESIGN_ASSIST_FLAG_NAMES} from './constants/ai-design-assist';
import {ANALYZE_FLAG_NAMES} from './constants/analyze';
import {ASSET_FLAG_NAMES} from './constants/assets';
import {CAMPAIGN_FLAG_NAMES} from './constants/campaign';
import {CMS_AUTHORING_FLAG_NAMES} from './constants/cms-authoring';
import {CMS_EXTENSIBILITY_FLAG_NAMES} from './constants/cms-extensibility';
import {CODE_FLAG_NAMES} from './constants/code';
import {CODE_GEN_FLAG_NAMES} from './constants/code-gen';
import {CODE_SYNC_FLAG_NAMES} from './constants/code-sync';
import {COLLABORATION_FLAG_NAMES} from './constants/collaboration';
import {CORE_INFRASTRUCTURE_FLAG_NAMES} from './constants/core-infrastructure';
import {CLOUD_FLAG_NAMES} from './constants/cloud';
import {DESIGN_SYSTEM_FLAG_NAMES} from './constants/design-system';
import {DESIGNER_PERFORMANCE_FLAG_NAMES} from './constants/designer-performance';
import {DESIGN_EXPERIENCE_FLAG_NAMES} from './constants/design-experience';
import {DEVELOPER_PLATFORM_FLAG_NAMES} from './constants/developer-platform';
import {FORMS_FLAG_NAMES} from './constants/forms';
import {IDSC_FLAG_NAMES} from './constants/idsc';
import {LIFECYCLE_FLAG_NAMES} from './constants/lifecycle';
import {LOCALIZATION_FLAG_NAMES} from './constants/localization';
import {LOGIC_DEPRECATION_FLAG_NAMES} from './constants/logic-deprecation';
import {OPTIMIZE_FLAG_NAMES} from './constants/optimize';
import {ODS_FLAG_NAMES} from './constants/ods';
import {USER_EXPANSION_FLAG_NAMES} from './constants/user-expansion';
import {SHARED_SERVICES_FLAG_NAMES} from './constants/shared-services';
import {SITE_DISCOVERY_FLAG_NAMES} from './constants/site-discovery';
import {SITE_RELIABILITY_FLAG_NAMES} from './constants/site-reliability';
import {SP_SUCCESS_FLAG_NAMES} from './constants/sp-success';
import {STRUCTURE_FLAG_NAMES} from './constants/structure';
import {SOURCE_FLAG_NAMES} from './constants/source';
import {STYLES_FLAG_NAMES} from './constants/styles';
import {SUBSCRIPTION_AND_PAYMENTS_FLAG_NAMES} from './constants/subscription-and-payments';
import {TRUST_AND_SAFETY_FLAG_NAMES} from './constants/trust-and-safety';
import {WORKFLOWS_FLAG_NAMES} from './constants/workflows';
import {CONTENT_FLAG_NAMES} from './constants/content';
import {PRIVATE_HOSTING_FLAG_NAMES} from './constants/private-hosting';

// Exported for enumeration of assets-owned flags.
export {ASSET_FLAG_NAMES} from './constants/assets';
export {MONGO_OPERATIONAL_WORKLOAD_TYPE} from './constants/ods';

export const FEATURE_FLAGS = {
  // if you own any of the following flags, please move them into a separate file
  // inside the constants directory, so that we can apply codeowners to the
  // appropriate feature team - or, even better, move the constants to a
  // file within your own feature code!

  // trust & safety
  FORM_EMAIL_TEMPLATE_VALIDATION: 'ff-ts-327-form-email-template-validation',
  ACCOUNT_TAKEDOWN_API: 'ff-ts-342-account-takedown-api',

  // dashboard
  DASHBOARD_NEXT_UNAUTH: 'ff-dash-3983-unauth-dashboard-next',
  ENTERPRISE_SUPPORT_PORTAL_LINK_IN_DASHBOARD:
    'ff-cxp-114-enterprise-support-portal-link-in-dashboard',

  // designer reusability
  EXPORT_QUEUE: 'ff-desru-79-export-queue',

  // per page js
  PER_PAGE_JAVASCRIPT: 'ff-per-page-javascript',
  RSPACK_CORE_2: 'ff-wrkf-4245-rspack-core-2',

  // campaigns
  CAMPAIGN_BUILD_MODE: 'ff-cam-26-campaigns',

  ...AEO_FLAG_NAMES,
  ...AETHER_FLAG_NAMES,
  ...AGENT_ACCESS_FLAG_NAMES,
  ...AI_DESIGN_ASSIST_FLAG_NAMES,
  ...ANALYZE_FLAG_NAMES,
  ...ASSET_FLAG_NAMES,
  ...CAMPAIGN_FLAG_NAMES,
  ...CMS_AUTHORING_FLAG_NAMES,
  ...CMS_EXTENSIBILITY_FLAG_NAMES,
  ...CODE_FLAG_NAMES,
  ...CODE_GEN_FLAG_NAMES,
  ...CODE_SYNC_FLAG_NAMES,
  ...COLLABORATION_FLAG_NAMES,
  ...CONTENT_FLAG_NAMES,
  ...CORE_INFRASTRUCTURE_FLAG_NAMES,
  ...CLOUD_FLAG_NAMES,
  ...DESIGN_SYSTEM_FLAG_NAMES,
  ...DESIGNER_PERFORMANCE_FLAG_NAMES,
  ...DESIGN_EXPERIENCE_FLAG_NAMES,
  ...DEVELOPER_PLATFORM_FLAG_NAMES,
  ...FORMS_FLAG_NAMES,
  ...IDSC_FLAG_NAMES,
  ...LIFECYCLE_FLAG_NAMES,
  ...LOCALIZATION_FLAG_NAMES,
  ...LOGIC_DEPRECATION_FLAG_NAMES,
  ...OPTIMIZE_FLAG_NAMES,
  ...PRIVATE_HOSTING_FLAG_NAMES,
  ...ODS_FLAG_NAMES,
  ...USER_EXPANSION_FLAG_NAMES,
  ...SHARED_SERVICES_FLAG_NAMES,
  ...SITE_DISCOVERY_FLAG_NAMES,
  ...SITE_RELIABILITY_FLAG_NAMES,
  ...SP_SUCCESS_FLAG_NAMES,
  ...STRUCTURE_FLAG_NAMES,
  ...SOURCE_FLAG_NAMES,
  ...STYLES_FLAG_NAMES,
  ...SUBSCRIPTION_AND_PAYMENTS_FLAG_NAMES,
  ...TRUST_AND_SAFETY_FLAG_NAMES,
  ...WORKFLOWS_FLAG_NAMES,

  // misc
  OSMOSIS_LOGGING: 'ff-misc-osmosis-logging',
} as const;

export type FeatureFlagName =
  | (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]
  | string;

export const STATSIG_CONFIG_SPECS_CACHE_KEY_PREFIX =
  'statsig|/v1/download_config_specs|';
